import { PartAnimatedState, PartState } from '../types';
import { buzzingState } from './buzzing';
import { curiousState } from './curious';
import { disappointedState } from './disappointed';
import { excitedState } from './excited';
import { searchingState } from './searching';
import { thinkingState } from './thinking';

// Re-export bored SVG component
export { BoredSVG } from './bored';

// Combined state parts for part-based animation
export const STATE_PARTS: Record<PartAnimatedState, PartState> = {
	curious: curiousState,
	thinking: thinkingState,
	disappointed: disappointedState,
	excited: excitedState,
	searching: searchingState,
	buzzing: buzzingState,
};
